import { render } from "./Attendance.vue?vue&type=template&id=051336c9&scoped=true&ts=true"
import script from "./Attendance.vue?vue&type=script&lang=ts"
export * from "./Attendance.vue?vue&type=script&lang=ts"

import "./Attendance.vue?vue&type=style&index=0&id=051336c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051336c9"]])

export default __exports__